/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Download_Waiting_For_NetworkInputs */

const en_mobile_download_waiting_for_network = /** @type {(inputs: Mobile_Download_Waiting_For_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You're offline. The download will start when you're back online.`)
};

const es_mobile_download_waiting_for_network = /** @type {(inputs: Mobile_Download_Waiting_For_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No tienes conexión. La descarga empezará cuando vuelvas a estar en línea.`)
};

/**
* | output |
* | --- |
* | "You're offline. The download will start when you're back online." |
*
* @param {Mobile_Download_Waiting_For_NetworkInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_download_waiting_for_network = /** @type {((inputs?: Mobile_Download_Waiting_For_NetworkInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Download_Waiting_For_NetworkInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_download_waiting_for_network(inputs)
	return en_mobile_download_waiting_for_network(inputs)
});